import { Data2, dateToString, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { useSystemStateHooks } from '../../system'
import { Transaction, TransactionDestinationType, TransactionSourceType } from '../state/types'

export const useTransactionBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildTransaction = (data: Data2) => {
        const { id = newId(), date, sourceType, sourceId, amount, destinationType, destinationId, concept } = data
        const transaction: Transaction = {
            companyId: companyId!,
            id: id! as string,
            date: dateToString(date || new Date())!,
            sourceType: sourceType! as TransactionSourceType,
            sourceId: sourceId as O<string>,
            amount: amount! as number,
            destinationType: destinationType! as TransactionDestinationType,
            destinationId: destinationId as O<string>,
            currency: Currency.ARS,
            concept: concept as O<string>
        }

        return transaction
    }

    return {
        buildTransaction
    }
}
